// T-178 (1) (v1.8.55, Session 43): Preiszeile der Tour im Schritt "Buchung prüfen" der Verwaltung ("Neue Buchung"). Bisher
// "Tour: 2 Personen × 67,50 €" auch mit ermäßigten Kindern (Betrag darunter richtig); jetzt je Kategorie wie in der Bestätigung.
// Reine Funktion, getestet in tourPreiszeile.test.ts.

export interface TourPreiszeileDaten {
  festpreis: boolean;
  teilnehmer: number;
  erwachsene: number;
  kinder6bis12: number;
  kinder3bis5: number;
  /** Kinder 0-2 und Freiplätze (ohne Berechnung) */
  frei: number;
  preisProPerson: number;
  kinderpreis6bis12: number;
  kinderpreis3bis5: number;
  staffel?: string;
}

export function tourPreiszeile(d: TourPreiszeileDaten, format: (betrag: number) => string): string {
  if (d.festpreis) return `Tour: Festpreis für ${d.teilnehmer} Personen`;
  const teile = [`${d.erwachsene} ${d.erwachsene === 1 ? 'Erwachsener' : 'Erwachsene'} × ${format(d.preisProPerson)}`];
  if (d.kinder6bis12 > 0) teile.push(`${d.kinder6bis12} ${d.kinder6bis12 === 1 ? 'Kind' : 'Kinder'} 6-12 × ${format(d.kinderpreis6bis12)}`);
  if (d.kinder3bis5 > 0) teile.push(`${d.kinder3bis5} ${d.kinder3bis5 === 1 ? 'Kind' : 'Kinder'} 3-5 × ${format(d.kinderpreis3bis5)}`);
  if (d.frei > 0) teile.push(`${d.frei} ohne Berechnung (Kinder 0-2, Freiplätze)`);
  return `Tour: ${teile.join(', ')}${d.staffel ? ` (${d.staffel})` : ''}`;
}
